
import api from '../api';

export const OPEN_LOGIN_DIALOG = 'login/OPEN_LOGIN_DIALOG';
export const CLOSE_LOGIN_DIALOG = 'login/CLOSE_LOGIN_DIALOG';

// Email login action types
export const EMAIL_LOGIN = "EMAIL_LOGIN";
export const EMAIL_LOGIN_PENDING = "EMAIL_LOGIN_PENDING";
export const EMAIL_LOGIN_REJECTED = "EMAIL_LOGIN_REJECTED";
export const EMAIL_LOGIN_FULFILLED = "EMAIL_LOGIN_FULFILLED";

const initialState = {
  loginDialogOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {

    case OPEN_LOGIN_DIALOG:
      return {
        ...state,
        loginDialogOpen: true
      };

    case CLOSE_LOGIN_DIALOG:
      return {
        ...state,
        loginDialogOpen: false
      };

    case EMAIL_LOGIN_PENDING:
      return {
        ...state,
        attemptingLogin: true,
      }

    case EMAIL_LOGIN_REJECTED:
      return {
        ...state,
        attemptingLogin: false,
        loginSuccess: false,
        error: action.payload,
      };

    case EMAIL_LOGIN_FULFILLED:
      return {
        ...state,
        attemptingLogin: false,
        loginSuccess: true,
      };

    // Facebook Login
    /*
    case FACEBOOK_LOGIN_PENDING:
      return {
        ...state,
        attemptingFacebookLogin: true,
      }

    case FACEBOOK_LOGIN_REJECTED:
      return {
        ...state,
        attemptingFacebookLogin: false,
        facebookLoginSuccess: false,
        error: action.payload,
      };

    case FACEBOOK_LOGIN_FULFILLED:
      return {
        ...state,
        attemptingFacebookLogin: false,
        facebookLoginSuccess: true,
      };
    */


    default:
      return state;
  }
};


// open the login dialog
export const openLoginDialog = () => {
  return dispatch => {
    dispatch({ type: OPEN_LOGIN_DIALOG });
  };
};

// Close the login dialog
export const closeLoginDialog = () => {
  return dispatch => {
    dispatch({ type: CLOSE_LOGIN_DIALOG });
  };
};


export function attemptLogin(data) {
  return {
    type: EMAIL_LOGIN,
    payload: api.login(data)
  };
}


// export function facebookLogin(data) {
//   return {
//     type: FACEBOOK_LOGIN,
//     payload: api.facebookLogin(data)
//   };
// }



// WEBPACK FOOTER //
// ./src/modules/login.js